export { KioskLandingPage as default } from '../../compositions';
